import { render, staticRenderFns } from "./paylaterAlert.vue?vue&type=template&id=210a9d82"
import script from "./paylaterAlert.vue?vue&type=script&lang=js"
export * from "./paylaterAlert.vue?vue&type=script&lang=js"
import style0 from "./paylaterAlert.vue?vue&type=style&index=0&id=210a9d82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports